import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Clock } from "lucide-react";
import { services } from "../data/siteData";

const categories = ["All", "Skin", "Lashes", "Brows", "PMU", "Body"];

const Bookings = () => {
  const [filter, setFilter] = useState("All");

  const list = useMemo(
    () => (filter === "All" ? services : services.filter((s) => s.category === filter)),
    [filter]
  );

  return (
    <div data-testid="bookings-page" className="bg-[#0a0a0a] pt-24 pb-10 lg:pt-28 lg:pb-16">
      {/* Header */}
      <section className="max-w-[1440px] mx-auto px-6 lg:px-12 mb-10 lg:mb-16">
        <p className="text-[var(--accent)] text-xs tracking-[0.32em] uppercase mb-5">Service Menu</p>
        <h1 className="font-display text-white text-[clamp(56px,10vw,170px)] leading-[0.9] reveal">
          Book
          <br />
          <span className="font-elegant italic font-light">your</span> ritual.
        </h1>
        <p className="text-white/70 max-w-2xl mt-5 lg:mt-8 leading-relaxed reveal delay-1">
          Choose from our full menu of skin, lash, brow, body, and permanent makeup
          rituals — each performed with intention by our Society artists.
        </p>
      </section>

      {/* Filters */}
      <section className="max-w-[1440px] mx-auto px-6 lg:px-12 mb-8 lg:mb-12">
        <div className="flex flex-wrap gap-3" data-testid="category-filters">
          {categories.map((c) => (
            <button
              key={c}
              onClick={() => setFilter(c)}
              data-testid={`filter-${c.toLowerCase()}`}
              className={`px-5 py-2.5 rounded-full border text-sm tracking-[0.15em] uppercase transition-all ${
                filter === c
                  ? "border-[var(--accent)] bg-[var(--accent)] text-[#0a0a0a]"
                  : "border-white/15 text-white/75 hover:border-[var(--accent)] hover:text-[var(--accent)]"
              }`}
            >
              {c}
            </button>
          ))}
        </div>
      </section>

      {/* Service grid */}
      <section className="max-w-[1440px] mx-auto px-6 lg:px-12">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {list.map((s) => (
            <article
              key={s.id}
              className="svc-card flex flex-col"
              data-testid={`booking-service-${s.id}`}
            >
              <div className="aspect-[4/3] overflow-hidden rounded-md mb-5 tile">
                <img src={s.img} alt={s.name} loading="lazy" />
              </div>
              <p className="text-[10px] tracking-[0.28em] uppercase text-[var(--accent)] mb-2">
                {s.category}
              </p>
              <h3 className="font-display text-white text-3xl mb-2">{s.name}</h3>
              <div className="thin-line my-3 opacity-50" />
              <p className="text-white/65 text-sm leading-relaxed mb-5 min-h-[42px]">
                {s.desc}
              </p>
              <div className="flex items-center justify-between mt-auto">
                <div>
                  <div className="font-display text-white text-2xl">${s.price}</div>
                  <div className="flex items-center gap-1.5 text-white/50 text-xs mt-1">
                    <Clock size={12} /> {s.duration}
                  </div>
                </div>
                <button
                  className="btn-accent text-sm"
                  data-testid={`book-btn-${s.id}`}
                  onClick={() => alert(`Booking flow for ${s.name} coming soon!`)}
                >
                  Book Now
                </button>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-12 lg:mt-20 text-center">
          <p className="text-white/55 text-sm mb-5">
            Can't find what you're looking for?
          </p>
          <Link to="/contact" className="btn-ghost" data-testid="contact-us-link">
            Contact Us <ArrowRight size={16} />
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Bookings;
